import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-shape shape-1" />
        <div className="gradient-shape shape-2" />
        <div className="gradient-shape shape-3" />
      </div>

      <div className="container hero-content">
        <div className="hero-text">
          <img 
            src="/logo.png" 
            alt="Latent Energy" 
            className="hero-logo"
          />

          <h1 className="hero-subtitle">
            Transforming unsorted plastic and complex packaging waste into circular-carbon commodities, sustainably and profitably.
          </h1>

          <div className="hero-cta">
            <a
              href="#contact"
              className="btn btn-primary"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-arrow">
          ↓
        </div>
      </div>
    </section>
  );
};

export default Hero;
